import call from './call';
import messageShow from "./messageShow";
import {UPDATE_DATA} from "../types";
import _ from "lodash";
import showConfirmation from "./showConfirmation";

const validateID= (formValues) => async (dispatch,getState) =>
{
    const state=getState();
    let queryParams = state.router.location.search ? _.reduce(state.router.location.search.substring(1).split("&"),
        (result, value) => {
            let params = value.split("=");
            result[params[0]] = params[1];
            return result;
        }, {}) : {};
    formValues.userName=queryParams.userName;
    if(!formValues.userName || formValues.userName==='')
    {
        dispatch(messageShow({message: "Usuario requerido", type: 'error'}));
        return;
    }
    const onResult= (result) =>
    {
        if(result && result[1])
        {
            if(result[1].success)
            {
                dispatch({type:UPDATE_DATA,payload:result[1]});
                //dispatch(showDocument());
                dispatch(showConfirmation());
            }
            else
                dispatch(messageShow({message: result[1].error, type: 'error'}));
        }
    }
    dispatch(call("Service/validateID",formValues,onResult));
};
export default validateID;